import { Form } from "antd"
import React from "react"
import { TextArea } from "../../../../../components/Input/TextArea.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"

interface FreeTextBlockProps {
  fieldKey: string
}

export function FreeTextBlock({ fieldKey }: FreeTextBlockProps) {
  return (
    <>
      <Form.Item
        name={["block_data", fieldKey, "title"]}
        label="Section Title"
        rules={[
          { required: true, whitespace: true, message: "Title is required" }
        ]}
      >
        <TextInput placeholder="Enter title" />
      </Form.Item>

      <Form.Item
        name={["block_data", fieldKey, "content"]}
        label="Content"
        rules={[
          { required: true, whitespace: true, message: "Content is required" }
        ]}
      >
        <TextArea placeholder={"Enter content"} rows={5} />
      </Form.Item>
    </>
  )
}
